module.exports = __webpack_public_path__ + "media/bootstrap-icons/dash-square-acd38c98.svg";